import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editSurveyAction = createAsyncThunk(
    'edit-survey-rewards',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/edit-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editSurveySlice = createSlice({
    name: 'create-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editSurveyReducer = editSurveySlice.reducer    